/**  MODIFIED COPY OF src/common-app/state/modules/engines/voice-mask/services.ts TODO find way to reuse common code! */
import { modules } from '@veritone/glc-redux';

const { user } = modules;
import { TDOId } from '@common-modules/universal/models/Brands';
import { selectConfigEngines } from '../selectors';
import callGraphQLApi, {
  GQLApiDispatch,
  GQLApiGetState,
} from '@helpers/callGraphQLApi';
import { speakerSeparationJobInput } from '@helpers/speakerSeparationDag';
import { selectTranscription } from '@common-modules/mediaDetails/selectors';

import {
  NOOP,
  CREATE_ENGINE_JOB_SUCCESS,
  CREATE_ENGINE_JOB_FAILURE,
  CHECK_JOB_STATUS_FAILURE,
  CHECK_JOB_STATUS_SUCCESS,
} from './actions';

export const createEngineJobService =
  ({
    tdoId,
    payload,
  }: {
    tdoId: TDOId;
    payload: {
      targetId: string;
      url: string;
    };
  }) =>
  async (dispatch: GQLApiDispatch, getState: GQLApiGetState) => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const state = getState();
    const {
      speakerSeparationEngineId,
      defaultClusterId,
      glcIngestionEngineId,
      outputWriterEngineId,
      transcriptionCategoryId,
    } = selectConfigEngines(state);
    const email = user.selectUser(state).email;

    if (!speakerSeparationEngineId) {
      throw new Error('Speaker separation engine ID not configured');
    }

    if (!glcIngestionEngineId) {
      throw new Error('GLC ingestion engine ID not configured');
    }

    const input = speakerSeparationJobInput({
      targetId: tdoId,
      clusterId: defaultClusterId,
      url: payload.url,
      glcIngestionEngineId,
      speakerSeparationEngineId,
      outputWriterEngineId,
      // The engine that actually produced the transcript on screen, not the
      // one currently configured: Redact picks a transcription engine per
      // language, so the configured id is the wrong answer for any transcript
      // run in another language or before a config change.
      transcriptEngineId: selectTranscription(state)?.engineId,
      transcriptCategoryId: transcriptionCategoryId,
      user: email,
    });

    return await callGraphQLApi<{
      createJob: {
        id: string;
        targetId: TDOId;
        status: string;
      };
    }>({
      actionTypes: [NOOP, CREATE_ENGINE_JOB_SUCCESS, CREATE_ENGINE_JOB_FAILURE],
      query: `mutation($input: CreateJob!) {
        createJob(input: $input) {
          id
          targetId
          status
        }
      }`,
      variables: { input },
      dispatch,
      getState,
    });
  };

/**
 * Get the status of a job.
 */
export const checkJobStatusService =
  ({ jobId }: { jobId: string }) =>
  async (dispatch: GQLApiDispatch, getState: GQLApiGetState) => {
    const query = `query($jobId: ID!) {
      job(id: $jobId) {
        id
        targetId
        status
      }
    }`;

    return await callGraphQLApi<{
      job: {
        id: string;
        targetId: TDOId;
        status: string;
      };
    }>({
      actionTypes: [NOOP, CHECK_JOB_STATUS_SUCCESS, CHECK_JOB_STATUS_FAILURE],
      query,
      variables: { jobId },
      dispatch,
      getState,
    });
  };
